import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

addToListLinkStyles.wrapper = {
    css: css`
        margin-top: 30px;
        text-align: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        text-align: center;  
                    `,
                    null,
                    null,
                    null,
                ],
                "minMax",
        )}
        > button[class^="StyledButton"] {
            &:before {
                content: "+";
                padding-right: 5px;
                font-size: 18px;
            }
            > span[class^="TypographyStyle"] {
                color: #000;
            }
        }
    `,
}
